module.exports = __webpack_public_path__ + "93f77794aea15c4ec23adadcaf8cead5.png";